import { combineReducers } from "redux"
import array from "./array"
import algorithm from "./algorithm"
import arrayState from "./arrayState"
import { ArrayState } from "./types"

export default combineReducers({
    array,
    algorithm,
    arrayState,
})

export interface IStoreState {
    array: number[]
    algorithm: string
    arrayState: ArrayState
}
